// 登記取得依頼の「経過日数」の範囲。取得依頼系の各フォーム（単体・一括・地図・
// モニタリング・アカウント設定・DataLens 一括取得）で共通の検証値
export const PAST_DAYS_MIN = 0;
export const PAST_DAYS_MAX = 1000;

export const PAST_DAYS_MIN_MESSAGE = `経過日数は${PAST_DAYS_MIN}日以上で入力してください`;
// 上限は桁区切りで表示する仕様（「1,000日」）。ロケールを固定して表記を確定させる
export const PAST_DAYS_MAX_MESSAGE = `経過日数は${PAST_DAYS_MAX.toLocaleString(
  "ja-JP"
)}日以内で入力してください`;
// 数値以外・未入力時の文言（zod の invalid_type_error / required_error 用）
export const PAST_DAYS_TYPE_MESSAGE = `経過日数を${PAST_DAYS_MIN}日以上で入力してください`;
